import { render, RenderResult } from '@testing-library/react';
import React from 'react';
import { Navigate, useRoutes, MemoryRouter } from 'react-router-dom';

import { paths } from '../paths';
import { authRoutes } from './auth';
import { backofficeRoutes } from './backoffice';
import { errorRoutes } from './error';

export const renderWithRouter = (ui: React.ReactElement): RenderResult =>
  render(
    <MemoryRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {ui}
    </MemoryRouter>
  );

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    {
      path: '/',
      element: <Navigate to={paths.backoffice.home} replace />,
    },

    {
      path: '/backoffice/',
      element: <Navigate to={paths.backoffice.home} replace />,
    },

    { path: '*', element: <Navigate to="/404" replace /> },

    ...authRoutes,

    ...errorRoutes,

    ...backofficeRoutes,
  ]);
}
